<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g style="stroke:#333;stroke-width:1.2px;fill:none" transform="translate(5 6)"><circle cx="3" cy="3" r="3" stroke="none" style="stroke:none"/><circle cx="3" cy="3" r="2.4" style="fill:none"/></g><g clip-path="path('M0 0h16v9H0z')"><g style="stroke:#333;stroke-width:1.2px;fill:none" transform="translate(-16190 -1627) translate(16190 1630)"><circle cx="8" cy="8" r="8" stroke="none" style="stroke:none"/><circle cx="8" cy="8" r="7.4" style="fill:none"/></g></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-show-password',
});
</script>
